/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MenuCosmicSupportTicketTracker.vue?vue&type=template&id=bb440e82&scoped=true"
import script from "./MenuCosmicSupportTicketTracker.ts?vue&type=script&lang=ts&external"
export * from "./MenuCosmicSupportTicketTracker.ts?vue&type=script&lang=ts&external"
import style0 from "./MenuCosmicSupportTicketTracker.vue?vue&type=style&index=0&id=bb440e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb440e82",
  null
  
)

export default component.exports